import React, { useEffect, useState } from 'react';
import styles from './style.module.css';
import axios from 'axios';

import { allQuestion, questionCategory } from '../../configs';

import { DashboardLayout } from '../../components/layouts';
import { QuestionCollections } from '../../components/parts';
import { LoadingSpinner } from '../../components/elements';

export default function Questionnaire() {
  // --for dummy--
  // const tabData = [
  //   {
  //     categoryId: 1,
  //     categoryName: 'Establish Enterprise Footprint',
  //   },
  //   {
  //     categoryId: 2,
  //     categoryName: 'Articulate Enterprise Ambition',
  //   },
  //   {
  //     categoryId: 3,
  //     categoryName: 'Identify Priority Basins',
  //   },
  //   {
  //     categoryId: 4,
  //     categoryName: 'Understand Basins Context',
  //   },
  // ];

  const [categoryList, setCategoryList] = useState();
  const [categoryTitle, setCategoryTitle] = useState();
  const [numberOfQuestions, setNumberOfQuestions] = useState(0);
  const [loading, setLoading] = useState(false);

  const loadCategoryDataAndQuestionCount = async (
    cancelTokenCategory,
    cancelTokenQuestion
  ) => {
    try {
      setLoading(true);

      // get data category & all question (for counting total question)
      const responseCategory = await axios.get(questionCategory, {
        cancelToken: cancelTokenCategory,
      });
      const responseQuestions = await axios.get(allQuestion, {
        cancelToken: cancelTokenQuestion,
      });

      // response for category
      if (responseCategory.status === 200) {
        let pushedData = responseCategory.data;
        const newData = [
          { categoryId: '98', categoryName: 'Water Source' },
          { categoryId: '99', categoryName: 'Receiving Water Body' },
        ];
        pushedData.push(newData[0]);
        pushedData.push(newData[1]);
        setCategoryList(pushedData);
        setCategoryTitle(`1. ${responseCategory.data[0].categoryName}`);
      }

      // response for allQuestion
      if (responseQuestions.status === 200) {
        const allQuestionData = responseQuestions.data;

        // count all questions.length in all category
        let numberTotalQuestion = 0;
        allQuestionData.forEach((element) => {
          numberTotalQuestion += parseInt(element.questions.length);
        });

        setNumberOfQuestions(numberTotalQuestion);
      }
      setLoading(false);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('fetch category/question count aborted.');
      } else {
        console.log(error.message);
        console.log(error.res);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const categorySource = axios.CancelToken.source();
    const questionSource = axios.CancelToken.source();

    loadCategoryDataAndQuestionCount(categorySource.token);

    return () => {
      categorySource.cancel();
      questionSource.cancel();
    };
  }, []);

  return (
    <DashboardLayout>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className={styles.root}>
          <h1 className={styles.pageTitle}>{categoryTitle}</h1>
          {/* <p className={styles.pageSubtitle}>
          Isi kuesioner yang tersedia sesuai ketentuan yang berlaku.
        </p> */}

          <QuestionCollections
            tabData={categoryList}
            // tabData={tabData}
            setCategoryTitle={setCategoryTitle}
            numberOfQuestions={numberOfQuestions}
          />
        </div>
      )}
    </DashboardLayout>
  );
}
